import React from 'react';
import './Header.css';

const Header = ({ title, description }) => {
  return (
    <div className="chatbot-header">
      <div className="header-content">
        <h1 className="header-title">
          <span className="header-icon">🤖</span>
          {title}
        </h1>
        <p className="header-description">{description}</p>
      </div>
    </div>
  );
};

export default Header;